/**
 * TODO: Move to common.
 * File to add table components so that it doesn't have to be defined in the component itsself.
 * Add more items here as needed.
 */

import React from 'react';
import { tokens } from "../../../public/tokens";

const { colors, typography, globals } = tokens;

/**
 * Get Header style to display on table.
 * @param {*} sorted Highlights if it's sorted or not.
 * @returns Header style.
 */
function getHeaderStyle(sorted, styleOverride) {
    return {
        color: sorted ? colors.neutral.white : colors.text.primary,
        background: sorted ? colors.neutral.black : 'transparent',
        fontSize: typography.fontSize["base-16px"],
        fontWeight: typography.fontWeights.semibold,
        fontFamily: globals["font-family"],
        lineHeight: "16px",
        ...styleOverride
    }
};

/**
 * Util to get components for table. Can be moved somewhere else.
 * @param {string|JSXComponent} label Label to display.
 * @param {boolean} sorted Highlighted, when sorting.
 * @param {Object} styleOverride Style overrides merged over the header style.
 * @returns JSXComponent
 */
export function getTableHeader(label, sorted = false, styleOverride = {}) {
    return <div style={getHeaderStyle(sorted, styleOverride)}>{label}</div>;
}

/**
 * Creates a clickable link-style button cell renderer for table rows.
 * 
 * @param {Object} params
 * @param {Function} params.onClick - Click handler receiving row.
 * @param {Function} [params.getLabel] - Returns button label from row.
 * @param {Function} [params.getTitle] - Returns tooltip text from row.
 * @param {Object} [params.textColors] - Theme colors (expects { link }).
 * @param {Object} [params.typography] - Font styles config.
 * @param {string} [params.className] - Button CSS classes.
 * @param {Object} [params.styleOverride] - Inline style overrides.
 * @returns {Function} Cell renderer (row) => JSX
 */
export function createLinkButtonCell ({
    onClick,
    getLabel = (row) => row.name,
    getTitle = (row) => row.name,
    className = "btn btn-link p-0 text-left",
    styleOverride = {},
}) {
    return (row) => (
        <button
            type="button"
            className={className}
            onClick={() => onClick?.(row)}
            style={{
                color: colors.text?.link,
                fontSize: typography?.fontSize?.["lg-14px"],
                fontWeight: typography?.fontWeights?.bold,
                textDecoration: "none",
                ...styleOverride,
            }}
        >
            <span title={getTitle(row)}>
                {getLabel(row) || "-"}
            </span>
        </button>
    );
}
